/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle(fn, freq) {
    var timestamp = 0;
    var threshold = 1000 / freq;
    var lastArgs;
    var timer;
    var invoke = function (args, now) {
        if (now === void 0) { now = Date.now(); }
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    var throttled = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var now = Date.now();
        var passed = now - timestamp;
        if (passed >= threshold) {
            invoke(args, now);
        }
        else {
            lastArgs = args;
            if (!timer) {
                timer = setTimeout(function () {
                    timer = null;
                    invoke(lastArgs);
                }, threshold - passed);
            }
        }
    };
    var flush = function () { return lastArgs && invoke(lastArgs); };
    return [throttled, flush];
}
export default throttle;
